export enum AuthErrorTypes {
  ERROR_TYPE_USER_EMAIL_NOT_CONFIRMED = 'expired',
}
